import React from 'react'
import Flex from 'typescript-styled-flex'
import { withTranslation } from 'react-i18next'
import Logo from '../../assets/logo-icalendar.png'
import theme from '../../theme/theme'
import { is } from '../MediaQuery'
import useSize from '../../hooks/useSize'
import { IntegrationWrapper } from './Wrapper'
import { Circle } from './Circle'
import { StyledLogoImg } from './Logo'

const IcalendarBar = () => {
  const isDesktop = is.desktop()
  const size = useSize()

  return (
    <Flex
      full={true}
      alignCenter={true}
      row={true}
      style={{
        background: '#ebedef',
        height: 'auto',
        minHeight: `${48 * size}px`,
        width: '100%',
      }}
    >
      <IntegrationWrapper
        size={size}
        style={{
          justifyContent: 'flex-start',
          maxHeight: isDesktop ? `${48 * size}px` : `${150 * size}px`,
        }}
      >
        <Flex>
          <Circle size={size} color={theme.colors.palette.icalendar} />
          <StyledLogoImg size={size} src={Logo} alt="logo icalendar" />
        </Flex>

        {/*<Flex alignBaseline={true} wrap={false} justifyCenter={!isDesktop}>*/}
        {/*<Label>{t('reservation_reservation_id')}</Label>*/}
        {/*<NumberLabel>{reservationId}</NumberLabel>*/}
        {/*</Flex>*/}
      </IntegrationWrapper>
    </Flex>
  )
}

export default withTranslation()(IcalendarBar)
